module.exports = __webpack_public_path__ + "img/FGr_Trinkwasser.c3b229d9.svg";